import component from './modalTemplate';

export default component;
